import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PartnerStepOne from "./PartnerSteps/PartnerStepOne";
import PartnerSteptwo from "./PartnerSteps/PartnerSteptwo";

import { useDispatch, useSelector } from "react-redux";
import {
  genericResetStepsReducer,
  intialState,
} from "../../Redux/AddOrEditPartner/AddOrEditPartnerSlice";
import PartnerStepThree from "./PartnerSteps/PartnerStepThree";
import PartnerStepFour from "./PartnerSteps/PartnerStepFour";
import PartnerStepFive from "./PartnerSteps/PartnerStepFive";
import { getCurrentPartnerStepInfoAction } from "../../Redux/AddOrEditPartner/AddOrEditPartnerActions";
import PartnerStepSix from "./PartnerSteps/PartnerStepSix";
import PageTitle from "../../Components/UI/PageTitle";
import Loader from "../../Components/Loader";
import StepIndicator from "../../Components/UI/StepIndicator";
const AddOrEditPartnerIntialState = { ...intialState };

const AddOrEditPartner = () => {
  const { loading } = useSelector((state) => state?.UI);

  let { type, userId } = useParams();
  const dispatch = useDispatch();
  const { currentStep } = useSelector((state) => state?.AddOrEditPartner);
  const navigate = useNavigate();
  const stepsArray = [
    { label: "Basic Data" },
    { label: "Verify Email" },
    { label: "Verify EMoney" },
    { label: "Package Data" },
    { label: "Complete Data" },
    { label: "Activate Partner" },
  ];

  useEffect(() => {
    dispatch(genericResetStepsReducer(AddOrEditPartnerIntialState));
    if (type === "edit" && userId) {
      dispatch(
        getCurrentPartnerStepInfoAction(
          userId,
          () => {},
          () => {
            navigate("/partners-list");
          }
        )
      );
    }
  }, [type]);

  useEffect(() => {
    if (currentStep == 7) {
      navigate("/partners");
    }
  }, [currentStep]);

  let AllSteps = [
    <PartnerStepOne />,
    <PartnerSteptwo />,
    <PartnerStepThree />,
    <PartnerStepFour />,
    <PartnerStepFive />,
    <PartnerStepSix />,
  ];

  if (loading) return <Loader />;

  const titleText = type === "edit" ? "Complete partner data" : "Add Partner";

  return (
    <>
      {type === "add" || type === "edit" ? (
        <>
          <PageTitle title={titleText} />
          <StepIndicator steps={stepsArray} currentStep={currentStep} />

          <div className="col-xl-12 !tw-p-0 tw-mt-10 max-lg:tw-mt-16">
            <div className="text-danger text-right tw-text-[12px] md:tw-text-[15px] tw-mb-2">
              * means this field is required{" "}
            </div>
            <div className="card !tw-rounded-xl tw-overflow-hidden">
              {AllSteps[currentStep - 1]}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default AddOrEditPartner;
